import React, { useEffect, useRef, useState } from "react";

import { TableNotification } from "../table_notification";

export const ScrollTableNotification: React.FC = (props) => {
  const [hasScroll, setHasScroll] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const table = entry.target;
        const tableWrapper = table.parentElement;
        if (tableWrapper) {
          setHasScroll(table.scrollWidth > tableWrapper.clientWidth);
        }
      });
    });
    if (wrapperRef.current) {
      const elements = wrapperRef.current.getElementsByTagName("table");
      if (elements.length > 0) {
        resizeObserver.observe(elements[0]);
      }
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <>
      {hasScroll && <TableNotification />}
      <div ref={wrapperRef} style={hasScroll ? { marginTop: "24px" } : undefined}>
        {props.children}
      </div>
    </>
  );
};
